import {priority} from '@priority-software/priority-proto-api/lib';

export type IColumn = priority.netitems.form.IColumn;

export type DataOption = {
    label: string;
    id: number;
    value: string;
    fixed: boolean;
};

const ColumnType = priority.netitems.form.ColumnType;

export const getSelectedFields = (
    availableFields: Array<DataOption>,
    selectedFields: Array<string>
) => {
    return selectedFields
        .filter(value => availableFields.find(field => field.value === value))
        .map(value => availableFields.find(field => field.value === value));
};

export const createOptionsFromCols = (cols: Array<IColumn>) =>
    cols.map(item => ({
        label: item.Title,
        id: Number(item.ID),
        value: item.Name,
        fixed: item.Type === ColumnType.Attachment
    }));
